import { Text } from '@thanx/uikit/text'
import { useStyletron } from 'baseui'
import { Label2 } from 'baseui/typography'
import { merchantTheme } from 'theme'

interface ReportItemProps {
  id: string
  title: string
  description: string
  isSelected: boolean
  onClick: (id: string) => void
}

const ReportItem = ({
  id,
  title,
  description,
  isSelected,
  onClick,
}: ReportItemProps) => {
  const [css] = useStyletron()

  return (
    <button
      type="button"
      data-testid="report-selector-item"
      aria-selected={isSelected}
      className={css({
        display: 'grid',
        gridTemplateColumns: '1fr',
        padding: '16px',
        alignItems: 'center',
        width: '100%',
        border: 'none',
        backgroundColor: isSelected
          ? merchantTheme.colors.belizeHole10
          : 'transparent',
        textAlign: 'left',
        cursor: 'pointer',
        ':hover': {
          backgroundColor: isSelected
            ? merchantTheme.colors.belizeHole10
            : merchantTheme.colors.grey10,
        },
      })}
      onClick={() => onClick(id)}
    >
      <div>
        <Label2
          $style={{
            color: merchantTheme.colors.grey90,
            fontWeight: 700,
          }}
        >
          {title}
        </Label2>
        <Text.BodyText5 color="grey70">{description}</Text.BodyText5>
      </div>
    </button>
  )
}

export default ReportItem
